// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dsv-content-wrapper.top-mode[data-v-388bf4cd]{padding-top:0}@media screen and (min-width:992px){#dsv-content-wrapper.top-mode[data-v-388bf4cd]{padding-top:114px}}", ""]);
// Exports
module.exports = exports;
